import { useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, ButtonRow } from "../App.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@material-ui/core";
import useImageUpload from "./useImageUpload";
import ImageThumbnailLoader from "./ImageThumbnail/ImageThumbnailLoader";
import { acceptedImages } from '../consts/accepted-files'

const ImageUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  .form-label {
    font-size: 0.8rem;
  }

  ${ButtonRow} {
    margin-top: 0.75rem;
    margin-bottom: 0.25rem;

    ${Button} {
      margin-right: 0.25rem;
      max-width: 200px;
      text-overflow: ellipsis;
    }
  }

  .photo-thumbnail__processing {
    font-size: 11px;
  }
`;

const FileWrapper = styled.div`
  margin-right: 0.5rem;

  input[type="file"] {
    display: none;
  }

  .form-control {
    font-size: 0.8rem;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    margin-bottom: 0.3125rem;
    padding: .625rem 1rem;
  }
`;

const UploadBtn = styled.label(({ theme }) => `
    display: inline-block;
    border-radius: ${theme.rounded.sm};

    &:focus {
        .btn {
            outline: 2px solid ${theme.accent2Color};
        }
    }
`);

const NewImageUpload = ({ label, name, type = "photo", useQuery, width = 75, height = 75, standalone = false }) => {
    const { t } = useTranslation();
    const inputFileRef = useRef(null);
    const handleFileLabel = (e) => {
        if (e.key !== "Enter" || inputFileRef.current === null) return;
        inputFileRef.current.click();
    };

    const {
        fileId,
        thumb,
        previewState: [preview],
        placeholderState: [placeholder],
        errorState,
        loadedState,
        upload,
        clear,
        isLoading,
        mediaIsProcessing,
    } = useImageUpload({ name, type, useQuery, standalone })

    const imageThumbnailLoaderProps = {
        alt: label,
        width,
        height,
        src: thumb,
        isLoading,
        errorState,
        loadedState,
        mediaIsProcessing,
    }

    return (
        <ImageUploadWrapper className="form-outline">
            {label && <label className="form-label">{label}</label>}
            {
                preview
                    ? (
                        <ImageThumbnailLoader {...imageThumbnailLoaderProps} />
                    )
                    : null
            }
            <ActionWrapper>
                <UploadBtn htmlFor={fileId} tabIndex={0} onKeyUp={handleFileLabel}>
                    <FileWrapper>
                        <input
                            accept={acceptedImages.join(',')}
                            className="form-control"
                            id={fileId}
                            type="file"
                            onChange={(evt) => {
                                const { target } = evt
                                upload(target.files[0])
                            }}
                            ref={inputFileRef}
                        />
                    </FileWrapper>
                    <Button tag="span" color="warning" className="btn--flat">
                        {t('Select File')}
                    </Button>
                </UploadBtn>
                {
                    preview
                        ? (
                            <Tooltip title={t(`Delete image`)}>
                                <Button onClick={clear} disabled={!!placeholder} color="danger" className="btn--flat">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Tooltip>
                        )
                        : null
                }
            </ActionWrapper>
        </ImageUploadWrapper>
    );
};

export default NewImageUpload;